var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQueryRightLayer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 545,
    height: 572,
    viewBox: "0 0 545 572",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M177.469 490.391L188.726 475.4L238.719 408.798L299.968 490.391H177.469Z",
    fill: "#00CC8F"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-6.31648e-05 426.093H96.5268L96.5337 426.1L48.2737 490.391H48.2599L-6.31648e-05 426.1V426.093Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M361.231 408.791L299.982 490.384H299.968L238.719 408.791L238.726 408.784H361.225L361.231 408.791Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177.485 491.225L117.234 571.483H237.732L177.485 491.225Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M483.737 245.576L483.744 245.583L422.494 327.176H422.481L361.231 245.583L361.238 245.576H483.737Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M299.982 327.179L361.231 245.586L422.48 327.179H299.982Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M422.487 327.193L361.238 408.786H361.224L299.975 327.193L299.982 327.179H422.48L422.487 327.193Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M361.231 82.3853L422.487 163.978H299.982L361.231 82.3853Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M422.494 163.978H422.487L361.231 82.385L361.238 82.3779H483.744V82.385L422.494 163.978Z",
    fill: "white",
    fillOpacity: 0.3
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M422.487 0.78418L483.744 82.377H361.238L422.487 0.78418Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M422.487 489.56L482.748 409.284H362.226L422.487 489.56Z",
    stroke: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M422.494 327.185H544.993L545 327.192L483.751 408.785H483.737H361.238L422.487 327.192L422.494 327.185Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M362.239 245.076H483.501L544.005 164.476H422.743L362.239 245.076Z",
    stroke: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M238.733 571.983H238.726H238.733L299.975 490.39L361.225 571.983H238.746H238.733Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M299.982 163.978H299.975L238.719 82.385L238.726 82.3779H361.231V82.385L299.982 163.978Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M116.206 409.624L55.9573 489.884H176.455L159.958 467.897L159.958 467.897L116.206 409.624Z",
    stroke: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M160.758 467.298L177.382 489.454L177.39 489.437L177.477 489.552L188.326 475.094L188.726 475.395L188.326 475.094L238.093 408.794L177.462 328.026L116.832 408.794L160.758 467.298L160.366 467.593L160.758 467.298ZM298.98 490.886H178.478L238.732 571.153L298.98 490.886ZM361.231 409.626L300.601 490.394L361.474 571.486H482.736L422.232 490.886H422.231L422.081 490.686L361.231 409.626Z",
    stroke: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M238.719 407.962L298.985 327.679H178.452L238.719 407.962Z",
    stroke: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M361.238 408.784L361.231 408.79L361.225 408.784H361.238Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M212.629 232.631L192.348 205.615L172.061 232.631H212.629Z",
    stroke: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M308.369 64.5618L275.948 21.3734L243.526 64.5618H308.369Z",
    stroke: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M238.719 82.3779H238.726L238.719 82.3836V82.3779Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9502 490.389L54.9433 490.383H54.957L54.9502 490.389Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M116.199 408.784H116.213L116.206 408.79L116.199 408.784Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M361.232 82.3779H361.238L361.232 82.3836V82.3779Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M177.456 327.179H177.469L177.462 327.194L177.456 327.179Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M360.236 246.076H239.714L299.975 326.352L360.236 246.076Z",
    stroke: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M300.982 164.476L361.238 244.743L421.492 164.476H300.982Z",
    stroke: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M299.982 163.976L361.238 245.576H238.698L299.982 163.976Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M361.258 571.99H361.245L300.002 490.411L300.009 490.397L300.002 490.39H422.501L422.508 490.397L361.258 571.99Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M238.718 571.99H238.698L177.462 490.411L177.469 490.397L177.462 490.39H299.954L299.961 490.397L238.718 571.99Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M299.982 163.978L238.712 82.4062L238.726 82.3921L238.719 82.3779H361.211L361.218 82.3921L299.982 163.978Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M422.795 327.34H422.782L361.539 245.761L361.546 245.747L361.539 245.733H484.038L484.045 245.747L422.795 327.34Z",
    fill: "#00CC8F"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M116.234 408.777L127.491 393.786L177.483 327.185L238.732 408.777H116.234Z",
    fill: "#00CC8F"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M133.311 431.571L116.206 408.784H238.705L177.456 490.377L133.311 431.571Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M219.868 236.566L256.638 285.547V285.554H256.631H183.098L219.868 236.566Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M422.145 490.342L360.916 571.906H422.145V490.342Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryRightLayer);
export default __webpack_public_path__ + "static/media/queryRightLayer.d62ac37e6b0ed32e5de59bafeff06ce4.svg";
export { ForwardRef as ReactComponent };